import React from 'react';
import AssetCollectionField from '../contentful/AssetCollectionField';

const GalleryBlock = ({onChange, value, working, predefinedTags}) => {
  const toggleFullscreen = (e) => {
    onChange({
      data: {
        ...(value.data || {}),
        fullwidth: e.target.checked
      }
    });
  };

  const toggleAutoslide = (e) => {
    onChange({
      data: {
        ...(value.data || {}),
        autoslide: e.target.checked,
        // autoslide is required for hideNavigation
        hideNavigation: !e.target.checked ? false : value.data?.hideNavigation
      }
    });
  };

  const autodelay = (e) => {
    onChange({
      data: {
        ...(value.data || {}),
        autodelay: e.target.value
      }
    });
  };

  const toggleHideNavigation = (e) => {
    onChange({
      data: {
        ...(value.data || {}),
        hideNavigation: e.target.checked
      }
    });
  };

  return <div>
    <div className="form-inline mf-margin-bottom-20 mf-margin-top-10">
      <div className="checkbox mf-margin-right-20"><label><input type="checkbox" value="" onChange={toggleFullscreen} name="fullwidth" defaultChecked={value.data?.fullwidth} /> Stort galleri</label></div>
      <div className="checkbox mf-margin-right-20"><label><input type="checkbox" value="" onChange={toggleAutoslide} name="autoslide" defaultChecked={value.data?.autoslide} /> Automatisk rullering</label></div>
      <select
        className="form-control mf-margin-right-20"
        defaultValue={value.data?.autodelay}
        onChange={autodelay}
        disabled={!value.data?.autoslide}
      >
        <option value="3000">3 Sekunder</option>
        <option value="4000">4 Sekunder</option>
        <option selected value="">5 Sekunder</option>
        <option value="10000">10 Sekunder</option>
        <option value="15000">15 Sekunder</option>
        <option value="20000">20 Sekunder</option>
        <option value="25000">25 Sekunder</option>
        <option value="30000">30 Sekunder</option>
      </select>
      <div className="checkbox mf-margin-right-20"><label><input type="checkbox" disabled={!value.data?.autoslide} value="" onChange={toggleHideNavigation} name="hideNavigation" defaultChecked={value.data?.hideNavigation} /> Skjul kontrollene</label></div>
    </div>
    <AssetCollectionField
      name="gallery"
      value={value.media}
      onChange={(_, value) => onChange({
        media: value
      })}
      disabled={working}
      predefinedTags={predefinedTags}
    />
  </div>;
};

export default GalleryBlock;
